import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";

import CampaignTemplateDetailsPanelForm, { FormInitialValues } from "./CampaignTemplateDetailsPanelForm";
import type { CampaignBuilderMode } from "../../../components/redesign/modules/CampaignBuilderForm";
import { ReduxApplicationState } from "../../../types/ReduxTypes/ReduxApplicationState";
import { setCampaignBasicDetails, setCampaignTemplateName } from "../../../redux/reducers/campaignToCreate";

type Props = {
  submitRef: React.RefObject<HTMLButtonElement>;
  mode?: CampaignBuilderMode;
};

const CampaignTemplateDetailsPanel: FC<Props> = ({ submitRef, mode = "template" }) => {
  const dispatch = useDispatch();
  const campaignTemplateName = useSelector(
    (state: ReduxApplicationState) => state.campaignToCreate.campaignTemplateName,
  );
  const basicDetails = useSelector((state: ReduxApplicationState) => state.campaignToCreate.basicDetails);

  const formInitialValues: FormInitialValues = {
    templateName: campaignTemplateName ?? "",
    name: basicDetails.name,
    description: basicDetails.description,
    mediaType: basicDetails.isVideoCampaign ? "video" : "display",
    showInHubspot: basicDetails.showInHubspot,
    maxCompanies: basicDetails.maxCompanies,
  };

  const handleSubmit = (values: FormInitialValues) => {
    if (mode !== "campaign") {
      dispatch(setCampaignTemplateName(values.templateName));
    }
    dispatch(
      setCampaignBasicDetails({
        name: values.name,
        description: values.description,
        isVideoCampaign: values.mediaType === "video",
        showInHubspot: values.showInHubspot,
        maxCompanies: +values.maxCompanies,
      }),
    );
  };

  return (
    <CampaignTemplateDetailsPanelForm
      ref={submitRef}
      formInitialValues={formInitialValues}
      handleSubmit={handleSubmit}
      mode={mode}
    />
  );
};

export default CampaignTemplateDetailsPanel;
